<template>
    <div>
        <div v-if="sci">
            <div v-if="!sci.archived" class="mt-4 bg-yellow-100 border-l-4 p-5 border-yellow-400 font-medium dark:bg-yellow-500/10 dark:border-yellow-500/40">
                <h4 class="text-gray-800 dark:text-gray-100">Archiver cette SCI</h4>
                <p class="text-sm text-gray-600 dark:text-gray-400">Cette action retirera la SCI de votre liste, vous pourrez toujours y accéder pour consulter les informations.</p>
                <button class="btn-warning mt-2" @click.prevent="confirmArchiveSci()">
                    Archiver
                </button>
            </div>
            <div v-else class="mt-4 bg-blue-100 border-l-4 p-5 border-blue-400 font-medium dark:bg-blue-500/10 dark:border-blue-500/40">
                <h4 class="text-gray-800 dark:text-gray-100">Désarchiver cette SCI</h4>
                <p class="text-sm text-gray-600 dark:text-gray-400">Cette action retirera la SCI des archives.</p>
                <button class="btn-info mt-2" @click.prevent="confirmUnarchiveSci()">
                    Désarchiver
                </button>
            </div>
        </div>
        <SpinnerLoader v-else class="mt-5"></SpinnerLoader>
        <div class="mt-4 bg-red-100 border-l-4 p-5 border-red-400 font-medium dark:bg-red-500/10 dark:border-red-500/40">
            <h4 class="text-gray-800 dark:text-gray-100">Supprimer cette SCI</h4>
            <p class="text-sm text-gray-400 dark:text-gray-400">Cette action supprimera complètement la SCI. Elle est irréversible.</p>
            <button class="btn-danger mt-2" @click.prevent="confirmRemoveSci()">
                Supprimer
            </button>
        </div>
    </div>
</template>

<script>

import { inject } from 'vue'
import SpinnerLoader from './../../components/loader/SpinnerLoader';

export default {
    components: {
        SpinnerLoader
    },
    data() {
        return {
            sci: {},
            loaded: false,
        }
    },
    created() {
        this.loadSci()
    },
    methods: {
        async loadSci() {
            const api = inject('api');

            this.loaded = false
            this.sci = await api.sci.getSci(this.$route.params.sciUuid);
            this.loaded = true
        },
        confirmArchiveSci() {
            this.$confirm({
                variant: 'warning',
                title: 'Archiver la SCI',
                message: "Êtes-vous sûr de vouloir archiver cette SCI. Cette action peut être réversible dans la section paramètre.",
                confirmText: 'Archiver',
                action: () => this.archiveSci(),
            });
        },
        confirmUnarchiveSci() {
            this.$confirm({
                variant: 'info',
                title: 'Désarchiver la SCI',
                message: "Désarchiver cette SCI.",
                confirmText: 'Désarchiver',
                action: () => this.unarchiveSci(),
            });
        },
        confirmRemoveSci() {
            this.$confirm({
                variant: 'danger',
                title: 'Supprimer la SCI',
                message: "Vous êtes sur le point de supprimer cette SCI. Cette action est irréversible, en êtes-vous sûr ?",
                confirmText: 'Supprimer',
                action: () => this.removeSci(),
            });
        },
        async archiveSci() {
            if (this.sci.archived || !this.sci.uuid) {
                return;
            }

            await this.$api.sci.archiveSci(this.sci.uuid)
            .then(() => {
                this.$toast({title: 'Succès', description: "La SCI à été archivé avec succès."}, this.$toastSuccess);
            })
            .catch((err) => {
                console.log(err);
                this.$toast({title: 'Erreur', description: "Une erreur est survenue, veuillez réessayer plus tard."}, this.$toastError);
            })

            this.$router.push({ name: 'sci' })
        },
        async removeSci() {
            if (!this.$route.params.sciUuid) {
                return;
            }

            await this.$api.sci.removeSci(this.$route.params.sciUuid)
            .then(() => {
                this.$toast({title: 'Succès', description: "La SCI à été supprimé avec succès."}, this.$toastSuccess);
            })
            .catch((err) => {
                console.log(err);
                this.$toast({title: 'Erreur', description: "Une erreur est survenue, veuillez réessayer plus tard."}, this.$toastError);
            })

            this.$router.push({ name: 'sci' })
        },
        async unarchiveSci() {
            if (!this.sci.archived || !this.sci.uuid) {
                return;
            }

            await this.$api.sci.unarchiveSci(this.sci.uuid)
            .then(() => {
                this.$toast({title: 'Succès', description: "La SCI à été désarchivé avec succès."}, this.$toastSuccess);
            })
            .catch((err) => {
                console.log(err);
                this.$toast({title: 'Erreur', description: "Une erreur est survenue, veuillez réessayer plus tard."}, this.$toastError);
            })

            this.$router.push({ name: 'sci' })
        },
    },
};
</script>